'use client'

interface Props {
    onOverride: () => void
}

/**
 * Self-override affordance for grader rejects (§5.0.3).
 *
 * Register: italic-serif, text-meta body-fg, hover→ink. Paper-on-paper.
 * NO vermilion (§5.0.5 — override pill adds zero new vermilion placements).
 * Tap target ≥44×44px via padding (hit box, not visual extent).
 *
 * Rendered inside the parent's aria-live="polite" region so its appearance
 * is announced to screen-reader users (§5.0.8).
 *
 * The parent is responsible for not mounting this component when the
 * override is blocked (third-encounter forced attempt).
 */
export function OverridePill({ onOverride }: Props) {
    return (
        <button
            type="button"
            onClick={onOverride}
            className="px-5 py-3 font-serif text-meta tracking-normal text-body-fg italic transition-colors duration-200 hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring motion-reduce:transition-none"
        >
            That was right
        </button>
    )
}
